export enum AccessLevel {
  /** Montagem de Remessas (operador de bancada/tótem). */
  OPERATOR = 'operator',
  /** Plano Packing: cadastros básicos + busca de combinações + instruções. */
  PACKING = 'packing',
  /** Pacote Otimizações: tudo de cliente (cadastros, cálculos, arquivos). */
  OTIMIZACAO = 'otimizacao',
  /** MK Digital: acessa tudo + administra empresas/usuários. */
  ADMIN_SUPER = 'admin_super',
  /** Estufamento de Cargas (módulo restrito). */
  CARGO_STUFFING = 'cargo_stuffing',
}

export const accessLevelDictionary: Record<AccessLevel, string> = {
  [AccessLevel.OPERATOR]: 'Montagem de Remessas',
  [AccessLevel.PACKING]: 'Packing',
  [AccessLevel.OTIMIZACAO]: 'Otimização',
  [AccessLevel.ADMIN_SUPER]: 'Administrador MK',
  [AccessLevel.CARGO_STUFFING]: 'Estufamento de Cargas',
};

export interface UserInterface {
  id: string;
  email: string;
  companyId: string;
  companyName: string;
  firstName: string;
  lastName: string;
  fullName: string;
  accessLevel: AccessLevel | null;
  role: AccessLevel | null;
  canGrantTrialAccess: boolean;
  /** Fim do teste da empresa (liberada pelo representante); null = sem prazo. */
  trialExpiresAt: string | null;
}
